import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["flowId"];
import { handleActions } from 'redux-actions';
import RequestState, { States, NOT_REQUESTED, REQUESTED, SUCCEEDED } from 'forms-utils-lib/RequestState';
import { FAIL_GETTING_FLOWS, RECEIVE_FLOWS, REQUEST_FLOWS } from 'ui-forms-editor-automation-lib/actions/fetchFlows';
import reduceFlows from 'ui-forms-editor-automation-lib/utils/reduceFlows';
import { SUCCESS_CREATING_A_NEW_WORKFLOW } from 'ui-forms-editor-automation-lib/actions/createNewWorkflow';
import { SUCCESS_CREATING_FOLLOW_UP } from 'ui-forms-editor-automation-lib/actions/createNewFollowUpEmail';
import DELETE_WORKFLOW_BY_ID from 'ui-forms-editor-automation-lib/constants/actions/DELETE_WORKFLOW_BY_ID';
import UPDATE_WORKFLOW_BY_ID from 'ui-forms-editor-automation-lib/constants/actions/UPDATE_WORKFLOW_BY_ID';
import UPDATE_WORKFLOW_VALIDATION_BY_ID from 'ui-forms-editor-automation-lib/constants/actions/UPDATE_WORKFLOW_VALIDATION_BY_ID';
import UPDATE_WORKFLOW_TYPES from 'ui-forms-editor-automation-lib/constants/UPDATE_WORKFLOW_TYPES';
export const INITIAL_STATE = {
  flows: [],
  flowValidations: {},
  error: {},
  requestState: NOT_REQUESTED,
  guid: null
};
export default handleActions({
  [REQUEST_FLOWS]: (_, {
    payload
  }) => ({
    flows: [],
    flowValidations: {},
    requestState: REQUESTED,
    error: {},
    guid: payload
  }),
  [RECEIVE_FLOWS]: (state, {
    payload
  }) => Object.assign({}, state, {
    flows: reduceFlows(payload.results),
    flowValidations: {},
    requestState: SUCCEEDED,
    error: {}
  }),
  [FAIL_GETTING_FLOWS]: (state, {
    payload
  }) => Object.assign({}, state, {
    flows: [],
    flowValidations: {},
    requestState: new RequestState({
      state: States.FAILED,
      error: payload
    }),
    error: payload
  }),
  [SUCCESS_CREATING_A_NEW_WORKFLOW]: (state, {
    payload
  }) => Object.assign({}, state, {
    flows: [...state.flows, ...reduceFlows([payload])]
  }),
  [SUCCESS_CREATING_FOLLOW_UP]: (state, {
    payload
  }) => Object.assign({}, state, {
    flows: [...state.flows, ...reduceFlows([payload])]
  }),
  [DELETE_WORKFLOW_BY_ID]: (state, {
    payload
  }) => Object.assign({}, state, {
    flows: state.flows.filter(flow => flow.flowId !== payload)
  }),
  [UPDATE_WORKFLOW_VALIDATION_BY_ID]: (state, _ref) => {
    let {
        payload: {
          flowId
        }
      } = _ref,
      validation = _objectWithoutPropertiesLoose(_ref.payload, _excluded);
    return Object.assign({}, state, {
      flowValidations: Object.assign({}, state.flowValidations, {
        [flowId]: validation
      })
    });
  },
  [UPDATE_WORKFLOW_BY_ID]: (state, {
    payload
  }) => Object.assign({}, state, {
    flows: state.flows.map(flow => {
      if (flow.flowId === payload.flowId) {
        switch (payload.type) {
          case UPDATE_WORKFLOW_TYPES.TOGGLE_WORKFLOW_ON:
            {
              return Object.assign({}, flow, {
                isEnabled: true
              });
            }
          case UPDATE_WORKFLOW_TYPES.TOGGLE_WORKFLOW_OFF:
            {
              return Object.assign({}, flow, {
                isEnabled: false
              });
            }
          case UPDATE_WORKFLOW_TYPES.UPDATE_FLOW_NAME:
            {
              return Object.assign({}, flow, {
                name: payload.name
              });
            }
          default:
            return flow;
        }
      }
      return flow;
    })
  })
}, INITIAL_STATE);